
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20.501 20.498"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.135 18.381l-4.562-4.562a8.631 8.631 0 10-1.754 1.754l4.562 4.562a1.24 1.24 0 101.754-1.754zM8.646 14.8A6.164 6.164 0 1113 12.994 6.148 6.148 0 018.646 14.8z"}})])
          )
        }
      }
    